import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Defaults mirror the backend DEFAULT_CONTENT so text never flashes empty.
export const DEFAULT_CONTENT = {
  hero_eyebrow: "Human Resource Advisory",
  hero_title: "Advisory for\nmodern teams",
  hero_tagline: "People · Process · Possibilities",
  hero_subtitle:
    "Peoplelab Advisory helps ambitious companies hire smarter, stay compliant, and build cultures people never want to leave. Fewer spreadsheets, more possibility.",
  hero_cta_primary: "Book a consultation",
  hero_cta_secondary: "Explore our services",
  services_eyebrow: "What we do",
  services_title: "Everything people, handled with care",
  services_subtitle:
    "Four core practices that cover the entire employee lifecycle — from the first hello to long-term growth.",
  approach_eyebrow: "Our approach",
  approach_title: "A manifesto for better work",
  approach_subtitle:
    "Three beliefs guide every engagement. They're simple, and that's exactly the point.",
  team_eyebrow: "Meet the team",
  team_title: "The people behind your people",
  testimonials_eyebrow: "Client proof",
  testimonials_title: "Teams that trust us to handle people",
  careers_eyebrow: "Careers",
  careers_title: "Build the future of work with us",
  careers_subtitle:
    "We're growing. If you love people and hate bureaucracy, you'll fit right in. Open a role to apply in seconds.",
  contact_eyebrow: "Contact",
  contact_title: "Let's build your team.",
  contact_subtitle:
    "Tell us where you're headed and we'll bring the people and the process. Real reply from a real human, promised.",
};

const ContentContext = createContext(DEFAULT_CONTENT);

export const useContent = () => useContext(ContentContext);

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  useEffect(() => {
    axios
      .get(`${API}/content`)
      .then((r) => setContent({ ...DEFAULT_CONTENT, ...r.data }))
      .catch(() => {});
  }, []);

  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>;
};
